<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h2>
          <v-icon class="mr-2">
            mdi-database-arrow-down
          </v-icon>
          交付等状況報告書
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-expansion-panels v-model="panels" accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して実行
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <validation-observer ref="reportManifestConditionValidate">
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="4">
                        <infinite-emission-auto-complete
                          :supplier-id="searchForms.emissionId"
                          :supplier-name="searchForms.emissionName"
                          classes="search-font"
                          rounded
                          only-valid-location
                          exclude-general
                          uncontrol-disabled
                          @update:values="emissionChangedCallback"
                        >
                          <template v-slot:append-outer>
                            <choose-emission-button
                            :without-general-form="true"
                            :without-invisible="false"
                            button-caption="排出事業者を選択"
                            only-valid-location
                            uncontrol-disabled
                            small-button
                            @choseEmissionCallback="choseEmissionCallback"
                            />
                          </template>
                        </infinite-emission-auto-complete>
                      </v-col>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="排出事業者名"
                        >
                          <v-text-field
                            v-model="searchForms.emissionName"
                            :error-messages="errors"
                            clearable
                            dense
                            hide-details="auto"
                            label="排出事業者名"
                            outlined
                            persistent-placeholder
                            rounded
                            placeholder="部分一致で検索"
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          class="requiredMark"
                          rules="required|numeric|max_value:9999"
                          name="報告対象年度"
                        >
                          <v-select
                            v-model="searchForms.fiscalYear"
                            :items="fiscalYears"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="報告対象年度"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="都道府県"
                        >
                          <v-autocomplete
                            v-model="searchForms.prefectureCode"
                            :items="prefList"
                            :error-messages="errors"
                            clearable
                            dense
                            hide-details="auto"
                            label="都道府県"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="出力方式"
                          class="requiredMark"
                        >
                          <v-select
                            v-model="searchForms.outputType"
                            :items="outputTypes"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="出力方式"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row v-if="environment !== 'production'">
                      <v-col cols="3">
                        <v-text-field
                          v-model="searchForms.manifestIds"
                          clearable
                          dense
                          hide-details="auto"
                          label="DXEマニ番号(テスト用です)"
                          outlined
                          persistent-hint
                          persistent-placeholder
                          placeholder="DXEマニ番号をカンマ区切りで入力"
                          hint="例: 1, 2, 3"
                          rounded
                          style="font-size: 80%"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      @click="exportButtonClickEvent"
                    >
                      <v-icon>mdi-file-download-outline</v-icon>
                      &nbsp;実行
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </validation-observer>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <output-files v-if="enableOutputFile" section="issuance" />
    <!-- アップグレード誘導モーダル -->
    <ec-contract-single-plan-guide-dialog
      :enable-dialog="enableEcContractSinglePlanGuideDialog"
      :from-report="true"
      @closeCallback="dialogCloseCallback"
    />
    <!-- /アップグレード誘導モーダル -->
  </v-container>
</template>
<script>

import PrefectureList from "../../../../mixins/PrefectureList";
import DownloadMixin from "../../../../mixins/download-mixin";
import {mapActions, mapGetters, mapState} from "vuex";
import OutputFiles from "../_OutputFiles.vue";
import EcContractSinglePlanGuideDialog from '../../dialogs/_EcContractSinglePlanGuideDialog'
import InfiniteEmissionAutoComplete from "@/driver/components/InfiniteEmissionAutoComplete.vue";
import ChooseEmissionButton from "@/driver/components/ChooseEmissionButton.vue";

export default {
  name: "DriverReportsIssuanceStatuses",
  components: {
    ChooseEmissionButton,
    InfiniteEmissionAutoComplete,
    OutputFiles,
    EcContractSinglePlanGuideDialog,
  },
  mixins: [
    PrefectureList,
    DownloadMixin
  ],
  data () {
    return {
      environment: process.env.VUE_APP_ENV,
      panels: 0,
      enableOutputFile: true,
      enableSearchEmissionDialog: false,
      selectableEmissionName: null,
      enableEcContractSinglePlanGuideDialog: false,
      selectableEmissionId: null,
      searchForms: {
        emissionId: null,
        emissionName: null,
        fiscalYear: null,
        prefectureCode: null,
        outputType: "pdf",
        manifestIds: null,
      },
      fiscalYears: [],
      outputTypes: [
        { value: "pdf", text: "PDF"},
        { value: "csv", text: "CSV"},
      ]
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'loginId'
    ]),
    ...mapState("DriverTenantConfiguration", {
      isEcContractSinglePlan: 'use_ec_contract_single_plan',
    }),
  },
  created () {
    const systemYear = new Date().getFullYear()
    this.fiscalYears = Array.from({length: 10}, (v, k) => systemYear - k)
    this.searchForms.fiscalYear = systemYear - 1

  },
  methods: {
    ...mapActions("DriverReportIssuanceStatus", {
      outputIssuanceStatuses: "create",
    }),
    emissionChangedCallback (emission_id, name) {
      this.searchForms.emissionId = emission_id;
      // this.searchForms.emissionName = name;
    },
    choseEmissionCallback(emissionDetail) {
      this.searchForms.emissionId = emissionDetail.id;
      // this.searchForms.emissionName = emissionDetail.name;
    },
    exportButtonClickEvent() {
      /** 電子契約単体プランの場合、メッセージを出して終わる */
      if (this.isEcContractSinglePlan) {
        this.enableEcContractSinglePlanGuideDialog = true
      } else {
        const params = this._buildParams()
        this.outputIssuanceStatuses({conditions: params}).then(() => {
          this.enableOutputFile = false;
          this.$nextTick(() => (this.enableOutputFile = true));
        })
      }
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
     dialogCloseCallback () {
      this.enableEcContractSinglePlanGuideDialog = false
    },
    _buildParams() {
      return {
        emission_id: this.searchForms.emissionId,
        emission_name: this.searchForms.emissionName,
        fiscal_year: this.searchForms.fiscalYear,
        prefecture_code: this.searchForms.prefectureCode,
        output_type: this.searchForms.outputType,
        manifest_ids: this.searchForms.manifestIds,
      }
    }
  },


}
</script>
